module.exports = __webpack_public_path__ + "img/4.9668e484.jpg";